import { toast } from 'sonner'

import { usePostUsersResetPasswordVerify } from '@/shared/api'
import { AXIOS_INSTANCE } from '@/shared/api/axios-client'
import { ERROR_CODE } from '@/shared/model'

import { useAuthTokenSetter } from '../../model/hooks/use-auth-token.setter'

export const useResetPassword = ({ isReset = false }: { isReset?: boolean } = {}) => {
    const { tokenSetter } = useAuthTokenSetter()

    const {
        mutate: resetPassword,
        mutateAsync: resetPasswordAsync,
        isPending,
    } = usePostUsersResetPasswordVerify({
        mutation: {
            onSuccess: (response) => {
                AXIOS_INSTANCE.defaults.headers.Authorization = `Bearer ${response.access_token}`

                tokenSetter(response.access_token)

                toast.success('Вы успешно авторизовались')
            },
            onError: (error) => {
                let errorMessage = 'Ошибка при сохранении, повторите попытку'

                if (error.error_code === ERROR_CODE.VERIFICATION_CODE_NOT_FOUND) {
                    errorMessage = isReset
                        ? `Срок действия ссылки истёк. Напишите на почту ${__GLOBAL__.VITE_SUPPORT_EMAIL}, чтобы получить новую`
                        : `Срок действия ссылки истёк. Обратитесь к менеджеру, чтобы получить новую`
                }

                toast.error(errorMessage)
            },
        },
    })

    return {
        resetPassword,
        resetPasswordAsync,
        isPending,
    }
}
